import React, { useEffect, useState } from "react";
import ModalImage from "react-modal-image";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useDispatch } from "react-redux";
import { fetchFileBlob } from "../pages/journey/journeySlice";
import { showErrorDialog } from "./dialog";

export const ImageViewer = ({ url }) => {
  const dispatch = useDispatch();
  const [isValidImage, setIsValidImage] = useState(null); // null = belum dicek

  console.log(url, "url");
  console.log(isValidImage, "isValidImage");

  useEffect(() => {
    if (!url) {
      setIsValidImage(null);
      return;
    }

    // Gunakan Image() agar tidak kena CORS
    const img = new Image();
    img.onload = () => setIsValidImage(true);
    img.onerror = () => setIsValidImage(false);
    img.src = url;
  }, [url]);

  // Kalau url belum ada
  if (!url) {
    return (
      <div
        style={{
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #ddd",
          borderRadius: 4,
          color: "#aaa",
          fontSize: 12,
        }}
      >
        <img
          src={toAbsoluteUrl("/media/img/no-image.png")}
          alt="No Image"
          style={{ width: "90px", height: "90px", opacity: 0.6 }}
        />{" "}
      </div>
    );
  }

  // Saat masih loading
  if (isValidImage === null) {
    return (
      <div
        style={{
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #ddd",
          borderRadius: 4,
          color: "#999",
          fontSize: 12,
        }}
      >
        Checking...
      </div>
    );
  }

  // Kalau tidak valid (404)
  if (!isValidImage) {
    return (
      <div
        style={{
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #ddd",
          borderRadius: 4,
          color: "#888",
          fontSize: 12,
        }}
      >
        <img
          src={toAbsoluteUrl("/media/img/no-image.png")}
          alt="No Image"
          style={{ width: "90px", height: "90px", opacity: 0.6 }}
        />{" "}
      </div>
    );
  }

  const handleDownload = async () => {
    try {
      const response = await dispatch(fetchFileBlob(url));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/jpg",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `image.jpg`;
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        margin: "5px",
      }}
    >
      {/* Floating download button */}
      <div
        onClick={handleDownload}
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderRadius: "50%",
          padding: "6px",
          cursor: "pointer",
          boxShadow: "0 0 5px rgba(0,0,0,0.3)",
          zIndex: 10,
        }}
      >
        <SVG
          src={toAbsoluteUrl("/media/svg/icons/Files/Download.svg")}
          className="svg-icon svg-icon-md svg-icon-secondary"
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      </div>

      {/* Image */}
      <ModalImage
        small={url}
        large={url}
        alt="Preview"
        hideDownload={true}
        smallImage={{
          style: {
            width: "150px",
            height: "150px",
            objectFit: "cover",
            borderRadius: "4px",
          },
        }}
      />
    </div>
  );
};
